import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=66aa7618&"
import script from "./Article.vue?vue&type=script&lang=ts&"
export * from "./Article.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockContentWithImage: require('/tmp/build_1fde6b87/src/components/block/ContentWithImage.vue').default})
